module.exports = __webpack_public_path__ + "img/camper_interiour_3.0198bd39.jpg";